import { EntityBadge, EntityBadgeProps } from "src/components/badges/entity";

/**
 * The properties for {@link TagBadge}
 */
export type TagBadgeProps = Omit<EntityBadgeProps, "entity" | "prefix" | "href" | "params"> & {
    /**
     * The tag this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    tag: { uuid: string; name: string; description?: string };
};

/**
 * A badge labeled `tag:name` linking to the tag's page
 */
export function TagBadge(props: TagBadgeProps) {
    const { tag, ...rest } = props;

    return (
        <EntityBadge
            {...rest}
            entity={tag}
            prefix={"tag"}
            href={"/a/tags/$tagId/associated"}
            params={{ tagId: tag.uuid }}
        />
    );
}
